import { ColorInfo } from "./types";

// Create color mapping
export const COLORS: ColorInfo[] = [
  { bg: "#E3F2FD", text: "#0D47A1" }, // Light blue
  { bg: "#E8F5E9", text: "#1B5E20" }, // Light green
  { bg: "#FFF3E0", text: "#E65100" }, // Light orange
  { bg: "#F3E5F5", text: "#4A148C" }, // Light purple
  { bg: "#FFEBEE", text: "#B71C1C" }, // Light red
  { bg: "#E0F7FA", text: "#006064" }, // Light cyan
  { bg: "#FFFDE7", text: "#F57F17" }, // Light yellow
  { bg: "#EFEBE9", text: "#3E2723" }, // Light brown
];
